import type { BodySerializer } from 'openapi-fetch';

export const formDataSerializer: BodySerializer<FormData> = (body): FormData => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(body as unknown as object)) {
    if (value === null || value === undefined) {
      continue;
    }

    if (value instanceof Blob) {
      formData.append(key, value);
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item instanceof Blob) {
          formData.append(key, item);
        } else if (item !== null && item !== undefined) {
          formData.append(key, String(item));
        }
      }
      continue;
    }

    formData.append(key, String(value));
  }

  return formData;
};
